"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copyright 2017-2022 @darwinia/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
// order important in structs... :)

/* eslint-disable sort-keys */
var _default = {
  rpc: {},
  types: {
    PowerOf: {
      power: 'Power'
    },
    PalletStakingIndividualExposure: {
      who: 'AccountId32',
      value: 'Compact<u128>'
    },
    RewardPoint: 'u32',
    SpanIndex: 'u32',
    UnappliedSlashOther: '(AccountId, RKT)'
  }
};
exports.default = _default;